var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"grid-dl text-body-2"},[_c('dt',{staticClass:"notranslate"},[_vm._v(" "+_vm._s(_vm.getLocalizedText(_vm.service.serviceData, "name"))+" ")]),_c('dd',{staticClass:"text-right"},[_c('summary-data-amount',{attrs:{"amount":_vm.totalServiceAmount}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }